import { Button, Tooltip } from '@arco-design/web-react';
import { IconMoonFill, IconSunFill } from '@arco-design/web-react/icon';
import React from 'react';
import { useTheme } from '@/hooks/useTheme';

export function ThemeButton() {
  const { theme, setTheme } = useTheme();
  return (
    <Tooltip content={theme === 'light' ? '点击切换为暗黑模式' : '点击切换为亮色模式'}>
      <Button
        icon={theme !== 'dark' ? <IconMoonFill /> : <IconSunFill />}
        shape="circle"
        type="secondary"
        onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      />
    </Tooltip>
  );
}
